import { getDataMapFromCommonResponse, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithParams, postSPDataWithoutParams } from './services'

// Support-scoped Google Business config for a clinic brand. Backed by
// /api/secure/cc/support/google-business (ROLE_CLINIC_SUCCESS_MANAGER/ADMIN + per-brand access).
// Paste-only: support staff can't complete the clinic's Google OAuth consent, so there is no
// connect/locations/disconnect here. Returns the same { ok, googleReviewUrl, googlePlaceId } shape
// as the owner service (src/shared/googleBusiness/googleBusinessService.js) so the shared
// GoogleBusinessSettings form can consume this bundle unchanged.

const BASE = '/api/secure/cc/support/google-business'

function messageOf(response, fallback) {
  return response?.data?.message || response?.response?.data?.message || response?.message || fallback
}

export async function getSupportGoogleBusinessConfig(clinicBrandId) {
  const response = await getSPDataWithParams(BASE, { clinicBrandId })
  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    const data = getDataMapFromCommonResponse(response) || {}
    return {
      ok: true,
      googleReviewUrl: data.googleReviewUrl || '',
      googlePlaceId: data.googlePlaceId || '',
    }
  }
  return { ok: false, message: messageOf(response, 'Unable to load Google Business settings.') }
}

export async function saveSupportGoogleBusinessConfig(clinicBrandId, googleReviewUrl, googlePlaceId) {
  const response = await postSPDataWithoutParams(BASE, { clinicBrandId, googleReviewUrl, googlePlaceId })
  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    const data = getDataMapFromCommonResponse(response) || {}
    return {
      ok: true,
      googleReviewUrl: data.googleReviewUrl || '',
      googlePlaceId: data.googlePlaceId || '',
    }
  }
  return { ok: false, message: messageOf(response, 'Unable to save Google Business settings.') }
}

// Paste-only service bundle for the shared <GoogleBusinessSettings services=… showConnectFlow={false} />.
export const supportGoogleBusinessServices = {
  getConfig: getSupportGoogleBusinessConfig,
  saveConfig: saveSupportGoogleBusinessConfig,
}
